import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeAudioAugmentedComponent } from './components/home-audio-augmented/home-audio-augmented.component';
import { HomeLatestStoriesComponent } from './components/home-latest-stories/home-latest-stories.component';
import { HomeHeaderComponent } from './components/home-header/home-header.component';
import { HomeFooterComponent } from './components/home-footer/home-footer.component';
import { HomeTransversalCategoriesComponent } from './components/home-transversal-categories/home-transversal-categories.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    HomeAudioAugmentedComponent,
    HomeLatestStoriesComponent,
    HomeHeaderComponent,
    HomeFooterComponent,
    HomeTransversalCategoriesComponent
  ],
  exports: [
    HomeAudioAugmentedComponent,
    HomeLatestStoriesComponent,
    HomeHeaderComponent,
    HomeFooterComponent,
    HomeTransversalCategoriesComponent
  ]
})
export class HomeUiModule {}
